// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.action-routine-card {
  background: var(--color-white);
  width: 100%;
  border-radius: var(--radius-md);
  padding: var(--space-4);
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  box-sizing: border-box;
  border: 1px solid var(--color-border-subtle);
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.1s ease;
}

.action-routine-card:hover {
  border-color: var(--color-gray);
  box-shadow: var(--shadow-sm);
}

/* Main content row */
.action-routine-card-main {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* Drag Handle */
.action-routine-card-drag-handle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: var(--color-dark-gray);
  cursor: grab;
  flex-shrink: 0;
  opacity: 0.4;
  transition: opacity 0.2s ease, color 0.2s ease;
  border-radius: 4px;
  padding: 2px;
}

.action-routine-card-drag-handle:hover {
  opacity: 0.8;
  color: var(--color-primary-green);
  background-color: var(--color-light-gray);
}

.action-routine-card-drag-handle:active {
  cursor: grabbing;
  opacity: 1;
}

/* Action Icon Area */
.action-routine-card-icon {
  width: 88px;
  height: 88px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.action-routine-card-icon-container {
  width: 100%;
  height: 100%;
  background-color: var(--color-pastelle-blue);
  border-radius: 8px;
  border: 1px solid var(--color-light-green);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-primary-green);
}

/* Content Area */
.action-routine-card-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: 0;
  height: auto;
  min-height: 88px;
}

.action-routine-card-texts {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.action-routine-card-type {
  color: var(--color-dark-gray);
  text-transform: uppercase;
}

.action-routine-card-name {
  color: var(--color-black);
}

.action-routine-card-description {
  color: var(--color-dark-gray);
  font-style: italic;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .action-routine-card {
    width: 100%;
    padding: 12px;
    gap: 12px;
    border-radius: 16px;
  }
  
  .action-routine-card-icon {
    width: 64px;
    height: 64px;
  }
  
  .action-routine-card-content {
    height: auto;
    justify-content: space-between;
    gap: 8px;
  }
  
  .action-routine-card-texts {
    gap: 4px;
  }
  
  .action-routine-card-drag-handle {
    display: none;
  }
}

/* Mobile Reordering Controls */
.action-routine-card-mobile-controls {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-left: 8px;
}

/* Show mobile controls on mobile devices */
@media (max-width: 768px) {
  .action-routine-card-mobile-controls {
    display: flex;
  }
}

/* Hide mobile controls on desktop */
@media (min-width: 769px) {
  .action-routine-card-mobile-controls {
    display: none;
  }
}

/* Order Warning Banner */
.action-routine-card-order-warning {
  margin-top: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/RoutineCard/ActionRoutineCard.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,WAAW;EACX,+BAA+B;EAC/B,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,4CAA4C;EAC5C,6EAA6E;AAC/E;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,8CAA8C;EAC9C,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,iCAAiC;EACjC,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4CAA4C;EAC5C,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA,iBAAiB;AACjB;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE;IACE,WAAW;IACX,aAAa;IACb,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,8BAA8B;IAC9B,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA,2CAA2C;AAC3C;EACE;IACE,aAAa;EACf;AACF;;AAEA,oCAAoC;AACpC;EACE;IACE,aAAa;EACf;AACF;;AAEA,yBAAyB;AACzB;EACE,aAAa;AACf","sourcesContent":[".action-routine-card {\n  background: var(--color-white);\n  width: 100%;\n  border-radius: var(--radius-md);\n  padding: var(--space-4);\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-3);\n  box-sizing: border-box;\n  border: 1px solid var(--color-border-subtle);\n  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.1s ease;\n}\n\n.action-routine-card:hover {\n  border-color: var(--color-gray);\n  box-shadow: var(--shadow-sm);\n}\n\n/* Main content row */\n.action-routine-card-main {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n/* Drag Handle */\n.action-routine-card-drag-handle {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  color: var(--color-dark-gray);\n  cursor: grab;\n  flex-shrink: 0;\n  opacity: 0.4;\n  transition: opacity 0.2s ease, color 0.2s ease;\n  border-radius: 4px;\n  padding: 2px;\n}\n\n.action-routine-card-drag-handle:hover {\n  opacity: 0.8;\n  color: var(--color-primary-green);\n  background-color: var(--color-light-gray);\n}\n\n.action-routine-card-drag-handle:active {\n  cursor: grabbing;\n  opacity: 1;\n}\n\n/* Action Icon Area */\n.action-routine-card-icon {\n  width: 88px;\n  height: 88px;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.action-routine-card-icon-container {\n  width: 100%;\n  height: 100%;\n  background-color: var(--color-pastelle-blue);\n  border-radius: 8px;\n  border: 1px solid var(--color-light-green);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--color-primary-green);\n}\n\n/* Content Area */\n.action-routine-card-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  min-width: 0;\n  height: auto;\n  min-height: 88px;\n}\n\n.action-routine-card-texts {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.action-routine-card-type {\n  color: var(--color-dark-gray);\n  text-transform: uppercase;\n}\n\n.action-routine-card-name {\n  color: var(--color-black);\n}\n\n.action-routine-card-description {\n  color: var(--color-dark-gray);\n  font-style: italic;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .action-routine-card {\n    width: 100%;\n    padding: 12px;\n    gap: 12px;\n    border-radius: 16px;\n  }\n  \n  .action-routine-card-icon {\n    width: 64px;\n    height: 64px;\n  }\n  \n  .action-routine-card-content {\n    height: auto;\n    justify-content: space-between;\n    gap: 8px;\n  }\n  \n  .action-routine-card-texts {\n    gap: 4px;\n  }\n  \n  .action-routine-card-drag-handle {\n    display: none;\n  }\n}\n\n/* Mobile Reordering Controls */\n.action-routine-card-mobile-controls {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-left: 8px;\n}\n\n/* Show mobile controls on mobile devices */\n@media (max-width: 768px) {\n  .action-routine-card-mobile-controls {\n    display: flex;\n  }\n}\n\n/* Hide mobile controls on desktop */\n@media (min-width: 769px) {\n  .action-routine-card-mobile-controls {\n    display: none;\n  }\n}\n\n/* Order Warning Banner */\n.action-routine-card-order-warning {\n  margin-top: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
